// Pure policy for the run-watchdog (extracted from main.js's _pumpRunWatchdog so
// the arm/clear decision is unit-testable). Returns "arm" to (re)start the 90s
// stall timer, "clear" to stop it, or null to leave it alone.
//
// agent_run_started is in the arm set: a cold-boot worker can take longer than
// the 90s window to produce its first real event, so the server's run-dispatch
// frame must reset the clock or a healthy-but-slow boot is misreported as
// "stopped responding".
const ARM = new Set([
  "agent_run_started",
  "agent_status",
  "agent_activity",
  "agent_message_delta",
  "agent_reasoning_delta",
  "agent_resumed",
]);
const CLEAR = new Set([
  "agent_final",
  "agent_error",
  "agent_permission_request",
  "agent_user_question",
  "agent_no_active_run",
]);

export function watchdogAction(type) {
  if (ARM.has(type)) return "arm";
  if (CLEAR.has(type)) return "clear";
  return null;
}

/**
 * What to do when the stall timer fires: "resume" (ask the server about this run) or
 * "error" (give up and show the recoverable error).
 *
 * Erroring straight away is what discarded the user's turn. The window is a guess made
 * on the client, and the server may still be perfectly busy — a slow cold boot can
 * outlast it — so the first move is to ASK: the socket accepts a resume at any time and
 * answers either with the events we missed or with "no active run". Only a stall that
 * survives that ask is really a dead run.
 *
 * `noActiveRun` short-circuits: the server has already told us there is nothing to
 * reattach to, so asking again is pointless.
 */
export function stallAction(state = {}) {
  if (state.noActiveRun) return "error";
  return state.triedResume ? "error" : "resume";
}
